module.exports = __webpack_public_path__ + "img/zubehoer_zentralabsaugung.c0e11917.jpg";